import React from "react";
import sasikumarBW from "../assets/sasikumar.png";
import sasikumarColor from "../assets/sasikumar-color.png";
import sasikumarBG from "../assets/sasikumar-bg.png";
import madanBW from "../assets/madan.png";
import madanColor from "../assets/madan-color.png";
import madanBG from "../assets/madan-bg.png";
import karthikBW from "../assets/Karthikk.png";
import karthikColor from "../assets/karthik-color.png";
import mohanBW from "../assets/mohan.png";
import mohanColor from "../assets/mohan-color.png";
import mohanBG from "../assets/mohan-bg.png";
import raguBW from "../assets/Ragu.png";
import raguColor from "../assets/Ragu-colorrr.png";
import emojiLaugh from "../assets/emoji1.png"; // 😂 emoji
import emojiStar from "../assets/emoji2.png"; // 🤩 emoji
import paperPlane from '../assets/paper-planee.png'; // Adjust if path differs
import contactStrip from "../assets/strip-images.png"; // Assume this is an array of image imports
import peopleImage from "../assets/people-lentera.png";
import yellowDot from "../assets/decor-yellow-dott.svg";
import pinkTriangle from "../assets/decor-pink-trianglee.svg";
import { motion } from "framer-motion";
import customerImage from "../assets/customerr.png";
import handImage from "../assets/hands.png";
import laptopGirlImage from "../assets/girl-laptop.png";
import sixPlusImage from "../assets/6plus.png";
import creativityImage from "../assets/creativity.png";
import underline from "../assets/underlinea.png";
import { useEffect, useState ,useRef} from 'react';
import w from "../assets/W.png";
import i1 from "../assets/I1.png";
import i2 from "../assets/I2.png";
import bg from "../assets/BG.png";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';
import { useNavigate } from 'react-router-dom'; 
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';
import {useAnimation } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import dd from "../assets/DD.png";
import ar from "../assets/Ar.png";
import logo from "../assets/logo.png";
import PersonCard from "./PersonCard"; // External card component

 

const PeopleSection = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        // const [isServicesOpen, setIsServicesOpen] = useState(false);
        // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
        // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
      
        const toggleMobileMenu = () => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        };
      
        // const toggleServicesDropdown = () => {
        //   setIsServicesOpen(!isServicesOpen);
        // };
      
        // const toggleIndustriesDropdown = () => {
        //   setIsIndustriesOpen(!isIndustriesOpen);
        // };
      
        // const toggleCompanyDropdown = () => {
        //   setIsCompanyOpen(!isCompanyOpen);
        // };
  const [data, setData] = useState("");
    const [sessionid, setSessionid] = useState("");
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    useEffect(() => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    }, []);
    useEffect(() => {
      const canvas = document.getElementById("captchaCanvas");
      if (canvas) {
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "bold 18px Arial";
        ctx.fillStyle = "#00377B";
        ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
      }
    }, [data]);
    const handleChange = (e) => {
      setEmail(e.target.value);
    };
   
     const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
   
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
   
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
   
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
   
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
   
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
   
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
   
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
   
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
   
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
   
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
   
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
      const handleSubscribe = async () => {
      try {
        const response = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/newsletter",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-TOKEN": token,
            },
            body: JSON.stringify({
              session_id: sessionid,
              captcha: userCaptcha,
              email: email,
              type: "Mawalog",
            }),
          }
        );
   
        const result = await response.json();
        console.log("Response:", userCaptcha, " ", data);
        setEmail("");
       setUserCaptcha("");
        toast(result.message);
      } catch (error) {
        console.error("Error sending request:", error);
      }
    };
    const [openDropdown, setOpenDropdown] = useState(null);
    const navRef = useRef(null);
  
    // Close dropdown on outside click
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
          setOpenDropdown(null);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  
    const toggleDropdown = (dropdown) => {
      setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };
    
    const navigate = useNavigate();
   
    const handleClick = () => {
      navigate("/Contact#contact-section");
    };
      const [isOpen, setIsOpen] = useState(false);
            
              // const toggleDropdown = () => {
              //   setIsOpen((prev) => !prev);
              // };
        
        
              const [isServicesOpen, setIsServicesOpen] = useState(false);
          const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          // Toggle functions for dropdowns
          const toggleServicesDropdown = () => {
            setIsServicesOpen(!isServicesOpen);
            setIsIndustriesOpen(false);
            setIsCompanyOpen(false); // Close other dropdowns
          };
        
          const toggleIndustriesDropdown = () => {
            setIsIndustriesOpen(!isIndustriesOpen);
            setIsServicesOpen(false);
            setIsCompanyOpen(false); // Close other dropdowns
          };
        
          const toggleCompanyDropdown = () => {
            setIsCompanyOpen(!isCompanyOpen);
            setIsServicesOpen(false);
            setIsIndustriesOpen(false); // Close other dropdowns
          };
              const [word, setWord] = useState('Today');
        
          useEffect(() => {
            const interval = setInterval(() => {
              setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
            }, 2000);
            return () => clearInterval(interval);
          }, []);
      
   
  const team = [
  {
    name: "Sasikumar S",
    title: "Founder & CEO",
    bwImage: sasikumarBW,
    colorImage: sasikumarColor,
    quote: "When you grow, we succeed your progress fuels our purpose",
  },
  {
    name: "Madan Kumar B",
    title: "Chief Technology Officer",
    bwImage: madanBW,
    colorImage: madanColor,
    quote: "Your progress inspires our passion to serve better",
  },
  {
    name: "Mohan Kumar S",
    title: "Customer Sales & Delivery Head",
    bwImage: mohanBW,
    colorImage: mohanColor,
    quote: "Don’t limit your challenges.Challenge your limits.",
  },
  {
    name: "Ragu Ram",
    title: "Technical Head",
    bwImage: raguBW,
    colorImage: raguColor,
    quote: "Action is the foundational key to all success",
  },
  {
    name: "Karthikeyan M",
    title: "IT Head",
    bwImage: karthikBW,
    colorImage: karthikColor,
    quote: "Never wait for your opportunity.Create your own.",
  },
];

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
    <div className="top-0 z-50 w-full">
  <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
    
    {/* Left Emoji */}
    <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiLeft}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>

    {/* Center Text and Emojis */}
    <div className="flex flex-wrap items-center justify-center gap-1 px-6 text-center leading-tight">
      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

     <span className="text-[11px] sm:text-[12px] md:text-[13px] leading-tight">
  We are proud to announce that we have completed&nbsp;
  <span className="text-green-700 font-semibold">6 successful years!</span>
</span>

      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiParty} alt="Party" className="h-4 w-4 sm:h-5 sm:w-5" />
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>

    {/* Right Emoji */}
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiRight}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>
  </div>
</div>

 <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
             <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
               {/* Logo */}
               <div className="flex items-center space-x-2">
                 <Link to="/">
                   <img
                     src={logo}
                     alt="Lentera Logo"
                     className="h-8 w-auto"
                   />
                 </Link>
               </div>
       
               {/* Hamburger Icon for Mobile */}
               <button
                 className="lg:hidden flex items-center"
                 onClick={toggleMobileMenu}
                 aria-label="Toggle mobile menu"
               >
                 <svg
                   className="h-6 w-6 text-gray-800"
                   fill="none"
                   stroke="currentColor"
                   viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d={isMobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                   />
                 </svg>
               </button>
       
               {/* Desktop Navigation */}
   <nav
       ref={navRef}
       className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
     >
       {/* --- Services Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('services');
             }}
           >
             Services
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'services' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
             {[
              { to: "/services/ai-services/", label: "AI Services" },
              { to: "/services/web-development/", label: "Web Development" },
              { to: "/services/mobile-app-development/", label: "Mobile App Development" },
              { to: "/services/software-consulting/", label: "Software Consulting" },
              { to: "/services/third-party-integration/", label: "Third Party Integration" },
              { to: "/services/custom-development/", label: "Custom Development" },
              { to: "/services/enterprise-application/", label: "Enterprise Application" },
              { to: "/services/digital-transformation/", label: "Digital Transformation" },
            ].map((item) => (
               <Link
                 key={item.to}
                 to={item.to}
                 className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
               >
                 <div className="flex items-center">
                   <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                   <span className="ml-2 text-xs">{item.label}</span>
                 </div>
                 <img
                   src={ar}
                   alt="Right arrow"
                   className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                 />
               </Link>
             ))}
           </div>
         )}
       </div>
 
       {/* --- Industries Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('industries');
             }}
           >
             Industries
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'industries' && (
            <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              
              { to: "/industries/logistics/", label: "Logistics" },
              { to: "/industries/healthcare/", label: "Healthcare" },
              { to: "/industries/financial-services/", label: "Financial Services" },
              { to: "/industries/education/", label: "Education" },
              { to: "/industries/hospitality/", label: "Hospitality" },
              { to: "/industries/entertainment/", label: "Entertainment" },
             { to: "/industries/energy/", label: "Energy" }, 
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
         )}
       </div>
 
       {/* --- Company Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('company');
             }}
           >
             Company
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'company' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
             {[
              { to: "/company/our-advantages/", label: "Our advantages" },
              { to: "/company/our-story/", label: "Our Story" },
              { to: "/company/people-of-lentera/", label: "People of Lentera" },
              { to: "/company/our-brand/", label: "Our Brand" },
              { to: "https://blog.lentera.in/", label: "Blogs", external: true },
              { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              // { to: "/company/certifications/", label: "Certifications" },
            ].map((item) =>
               item.external ? (
                 <a
                   key={item.to}
                   href={item.to}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                 >
                   <div className="flex items-center">
                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                     <span className="ml-2 text-xs">{item.label}</span>
                   </div>
                   <img
                     src={ar}
                     alt="Right arrow"
                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                   />
                 </a>
               ) : (
                 <Link
                   key={item.to}
                   to={item.to}
                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                 >
                   <div className="flex items-center">
                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                     <span className="ml-2 text-xs">{item.label}</span>
                   </div>
                   <img
                     src={ar}
                     alt="Right arrow"
                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                   />
                 </Link>
               )
             )}
           </div>
         )}
       </div>
 
       {/* --- Contact Link --- */}
       <Link to="/contact/" className="text-black hover:text-black">
         Contact us
       </Link>
     </nav>
       
               {/* Desktop Language Selector + CTA */}
               <div className="hidden lg:flex items-center gap-3">
                 {/* <button className="flex items-center gap-2 rounded-full border border-gray-300 px-4 py-1 text-sm font-medium text-gray-700 shadow-sm">
                   <img
                     src={ind}
                     alt="India Flag"
                     className="h-4 w-4 rounded-full"
                   />
                   India (English)
                   <ChevronDown className="h-4 w-4" />
                 </button> */}
                  <button
  onClick={handleClick}
  className="w-[175px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
>
  Get a Free Quote
</button>

               </div>
             </div>
       
             {/* Mobile Menu */}
             {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link>
                         <Link
                          to="/services/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                        
                        <Link
                          to="/industries/logistics/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Logistics
                        </Link>
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                        <Link
                          to="/industries/energy/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Energy
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/our-story/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Story
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                       {/* <Link
                        to="/company/certifications/"
                        className="block px-4 py-2 text-xs hover:bg-gray-100"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Certifications
                      </Link>   */}
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          <button
                 onClick={handleClick}
  className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
  // onClick={() => {
  //   const section = document.getElementById("contact-section");
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // }}
>
  Get a Free Quote
</button>

                </nav>
              </div>
            )}
           </header>
<section className="w-full bg-[#fdf6dc] font-poppins pb-24">
  {/* Header */}
  <div className="text-center px-4 pt-20">
    <h2 className="text-[40px] sm:text-[48px] font-semibold text-[#1E1E1E] leading-tight">
      People of Lentera
    </h2>
    <img
      src={underline}
      alt="underline"
      className="mx-auto mt-2 w-[80px] h-[2px]"
    />
    <p className="mt-6 text-base sm:text-lg text-[#3A3A3A] max-w-[700px] mx-auto leading-relaxed">
      A behind-the-scenes look at the people who shaped our craft— building the foundation of our culture and the products we proudly create today.
    </p>
  </div>

  {/* Team Cards */}
  <div className="mt-24 space-y-12 px-4">
    {/* Row 1 */}
    <div className="flex justify-center gap-8 flex-wrap">
      {team.slice(0, 3).map((member, index) => (
        <div
          key={index}
          className="group w-[320px] h-[320px] bg-white rounded-[14.62px] border border-[#E0E0E0] text-center shadow-sm relative"
        >
          {/* Image Box */}
          <div
            className="absolute -top-[10px] left-1/2 transform -translate-x-1/2 z-30 rounded-[14.62px] flex items-center justify-center overflow-hidden"
            style={{ width: '277.85px', height: '228.49px' }}
          >
            <img
              src={member.bwImage}
              alt={member.name}
              className="w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300 group-hover:opacity-0"
            />
            <img
              src={member.colorImage}
              alt={`${member.name} Color`}
              className="w-full h-full object-contain absolute top-0 left-0 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-105"
            />
          </div>

          {/* Text Content */}
          <div className="absolute bottom-6 left-0 w-full px-4">
            <div className="group-hover:hidden transition-opacity">
              <h3 className="text-[18px] font-semibold text-[#1E1E1E]">{member.name}</h3>
              <p className="text-sm text-[#6B6B6B] mt-1">{member.title}</p>
            </div>
            <div className="hidden group-hover:block">
              <p className="text-sm text-[#1E1E1E] italic leading-snug">“{member.quote}”</p>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 */}
    <div className="flex justify-center gap-8 flex-wrap">
      {team.slice(3, 5).map((member, index) => (
        <div
          key={index}
          className="group w-[314px] h-[320px] bg-white rounded-[14.62px] border border-[#E0E0E0] text-center shadow-sm relative"
        >
          {/* Image Box */}
          <div
            className="absolute -top-[20px] left-1/2 transform -translate-x-1/2 z-30 rounded-[14.62px] flex items-center justify-center overflow-hidden"
            style={{ width: '280.85px', height: '238.49px' }}
          >
            <img
              src={member.bwImage}
              alt={member.name}
              className="w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300 group-hover:opacity-0"
            />
            <img
              src={member.colorImage}
              alt={`${member.name} Color`}
              className="w-full h-full object-contain absolute top-0 left-0 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-105"
            />
          </div>

          {/* Text Content */}
          <div className="absolute bottom-6 left-0 w-full px-4">
            <div className="group-hover:hidden transition-opacity">
              <h3 className="text-[18px] font-semibold text-[#1E1E1E]">{member.name}</h3>
              <p className="text-sm text-[#6B6B6B] mt-1">{member.title}</p>
            </div>
            <div className="hidden group-hover:block">
              <p className="text-sm text-[#1E1E1E] italic leading-snug">“{member.quote}”</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



 


        <section className="w-full bg-white py-20 px-4 lg:px-16 font-poppins">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-start gap-12 relative">
        
        {/* Left Side (40%) */}
        <div className="w-full md:w-[40%] min-h-[505px] relative">
          
          {/* Emoji Laugh - Bottom Left of Heading */}
          <img 
            src={emojiLaugh} 
            alt="Laugh Emoji" 
            className="absolute top-0 left-0 w-12 h-12 md:w-14 md:h-14" 
          />

          {/* Emoji Star - Floating above right side of heading */}
          <img 
            src={emojiStar} 
            alt="Star Emoji" 
            className="absolute top-[10px] right-[100px] w-20 h-20 md:w-20 md:h-20" 
          />

          {/* Heading and Content */}
          <div className="mt-16">
            <h2 className="text-4xl md:text-[44px] font-semibold text-[#1A1A1A] leading-[52px] mb-6">
              Passionate work,<br /> playful connections
            </h2>

            {/* Green underline */}
            <div className="w-[72px] h-[2px] bg-green-600 mb-6" />

            {/* Description */}
            <p className="text-[#4B4B4B] text-[18px] leading-[30px] tracking-tight mb-8">
              At Lentera Technologies, we empower like-minded individuals with the freedom to thrive. With the right tools and support, your growth becomes our shared success.
            </p>

            {/* Paper plane */}
            <img 
              src={paperPlane} 
              alt="Paper Plane" 
              className="w-80 h-40 mt-4 ml-1"
            />
          </div>
        </div>
       

        {/* Right Side (60%) - Scrolling Strip */}
        <div className="relative w-[768px] h-[505px] overflow-hidden rounded-md">
          {/* Blur overlays */}
          <div className="absolute top-0 left-0 w-20 h-full z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 w-20 h-full z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" />

          {/* Scrolling strip */}
          <div className="flex w-max animate-scroll-seamless whitespace-nowrap">
            {[...Array(4)].map((_, i) => (
              <img
                key={i}
                src={contactStrip}
                alt={`contact-strip-${i}`}
                className="h-[505px] w-[768px] object-cover shrink-0"
              />
            ))}
          </div>

          {/* Scroll Animation */}
          <style>{`
            @keyframes scroll-seamless {
              0% {
                transform: translateX(0%);
              }
              100% {
                transform: translateX(-50%);
              }
            }
            .animate-scroll-seamless {
              animation: scroll-seamless 20s linear infinite;
            }
          `}</style>
        </div>
      </div>
    </section>
     <section className="w-full bg-white font-poppins relative overflow-hidden pb-24">
  {/* Top Team Image */}
  <img
    src={peopleImage}
    alt="People of Lentera"
    className="w-full object-cover h-auto max-h-[600px]"
  />

  {/* Content Card */}
  <div className="w-full flex justify-center -mt-20 px-4 relative z-10">
    <div className="bg-white rounded-[16px] shadow-xl w-full max-w-[1312px] px-6 md:px-[64px] lg:px-[84px] py-[56px] flex flex-col md:flex-row items-start justify-between relative">
      
      {/* Yellow Dot */}
      <img
        src={yellowDot}
        alt="Yellow Dot"
        className="absolute top-0 left-0 w-[60px] md:w-[76px] h-auto"
      />

      {/* Pink Triangle */}
      <img
        src={pinkTriangle}
        alt="Pink Triangle"
        className="absolute right-0 bottom-0 w-[100px] md:w-[125px] h-auto"
      />

      {/* Paper Plane */}
      <img
        src={paperPlane}
        alt="Paper Plane"
        className="absolute hidden sm:block left-[50%] md:left-[330px] bottom-[-40px] w-[200px] md:w-[300px] h-auto"
      />

      {/* Left Side */}
      <div className="w-full md:w-[440px] mb-8 md:mb-0">
        <h2 className="text-[40px] md:text-[48px] leading-[46px] md:leading-[52px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#7B41E6] to-[#ED72EF]">
          6+ years
        </h2>
        <p className="text-[18px] md:text-[20px] leading-[28px] md:leading-[32px] text-[#212129] font-medium mt-2">
          of running a business has taught us many things
        </p>
      </div>

      {/* Right Side: Quote */}
      <div className="w-full md:w-[580px]">
        <div className="border-l-[2px] border-[#07862B] pl-6 italic text-[16px] md:text-[18px] text-[#333] leading-[28px] md:leading-[30px]">
          “We believe that investing in our people leads to long-term
          commitment. We're proud and humbled that many of our colleagues
          have been with us for over a decade, growing alongside the
          company.”
        </div>
      </div>
    </div>
  </div>
</section>

<div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="http://localhost:3000/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
          <div className="flex items-start gap-3 mb-3">
  <img src={phone} alt="phone" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Phone number</p>
    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
      +91-44-4856-3345
    </a>
  </div>
</div>

<div className="flex items-start gap-3 mb-3">
  <img src={mail} alt="email" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Email address</p>
    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
      info@lenteratech.com
    </a>
  </div>
</div>

           <div className="flex items-start gap-3">
  <img src={loc} alt="location" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Location</p>
    <a
      href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white font-medium text-sm hover:underline block"
    >
      G1, Plot No, 824 and 826, 3rd<br />
      Main Rd, Ram Nagar South,<br />
      Madipakkam, Chennai,<br />
      Tamil Nadu 600091
    </a>
  </div>
</div>

         </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>

    </>
    
    

  );
};

export default PeopleSection;
